export interface IObservable<T> {
    value: T,
    update:(updater: any) => void
    subscribe:(sub: any) => void
    unsubscribe:(sub: any) => void
} 

export function Observable<T>(initialValue: T) {
	/* 
	   our observable maintains its own value, as well as an array of any
	   functions 'subscribed' to it, it will fire all these functions later
	*/
    let value = initialValue;
    let subscribers: any[] = [];

	 /* when we subscribe we add a new function to this array*/
    const subscribe = (subscriber: any) => {
        subscribers = [...subscribers, subscriber]
    }
    
    /* when we unsub we remove the function from the array*/
    const unsubscribe = (subscriber: any) => {
        subscribers = subscribers.filter(fn=>fn!==subscriber);
    }

    const update = (updater: typeof initialValue | Function) => {
	    /*
	    if we pass a function as an updater we run that function, otherwise we set 
	    the value i.e. you could pass something like (value) => value.toUpperCase()
	    if for whatever reason you wanted to update a string to uppercase, or you
	    can just pass it a value. Once it sets the value it runs all the subscribed function
	    with the new value
	    */
        if(updater instanceof Function){
          value = updater(value);
        } else {
          value = updater;
        }

        subscribers?.forEach((subscriber)=>subscriber(value))
    }

		/*
			we return a readonly version of the observable to make the code more secure
		*/
    return Object.freeze({
        get value(){ 
            return value
        },
        update,
        subscribe,
        unsubscribe
    })
}